module.exports = __webpack_public_path__ + "img/paycode.304c0363.jpg";